import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export const customersApiKeyStore = {
  getCustomer: (customerID?: any): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_BYID`, customerID],
    route: `/customer/${customerID}`,
    isEnabled: !!customerID,
  }),
  getCustomers: (): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMERS`],
    route: `/customer`,
  }),
  createCustomers: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_CUSTOMER`],
    route: `/customer`,
    action: 'POST',
  }),
  updateCustomers: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_CUSTOMER`],
    route: `/customer`,
    action: 'PUT',
  }),
  deleteCustomer: (customerID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_CUSTOMER`, customerID],
    route: `/customer/${customerID}`,
    action: 'PUT',
  }),
  getCustomerTypes: (): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMERS_TYPES`],
    route: `/Customer/GetCustomerTypes`,
  }),
  getInvoiceTerms: (): QueryKeyConfig => ({
    queryKey: [`GET_INVOICE_TERMS`],
    route: `/Customer/GetInvoiceTerms`,
  }),
  getCustomerProfileStatistics: (customerID?: number, formDate?: any, toDate?: any): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_PROFILESTAT`, customerID, formDate, toDate],
    route: `/customer/GetCustomerProfileStatistics?ID=${customerID}&FromDate=${formDate}&ToDate=${toDate}`,
    isEnabled: !!customerID,
  }),
  validateCustomer: (customerName?: string): QueryKeyConfig => ({
    queryKey: [`VALIDATE_CUSTOMER`, customerName],
    route: `/Customer/CustomerExists?customerName=${customerName}`,
  }),
  validateCustomerContact: (contactEmail: string, id: number): QueryKeyConfig => ({
    queryKey: [`VALIDATE_PROJECT`, contactEmail, id],
    route: `/Customer/ContactEmailExists?contactEmail=${contactEmail}&ID=${id}`,
  }),
  duxSyncStatusChange: (): MutationKeyConfig => ({
    mutationKey: [`DELETE_CUSTOMER`],
    route: `/Customer/DuxSyncStatusChange`,
    action: 'PUT',
    disableSnackbar: true,
  }),
};
